export enum DataSource {
  AccountCheckout = 'AccountCheckout',
  ClientDataLayer = 'ClientDataLayer',
  CreateAccount = 'CreateAccount',
  ContactUs = 'ContactUs',
  Complaints = 'Complaints',
  EditAccount = 'EditAccount',
  GuestCheckout = 'GuestCheckout',
  LoginForm = 'LoginForm',
  Newsletter = 'Newsletter',
  PasswordReset = 'PasswordReset',
  PersistedStorage = 'PersistedStorage',
  Quote = 'Quote',
  RetrieveOrder = 'RetrieveOrder',
  BookAppointment = 'BookAppointment',
  StockNotification = 'StockNotification',
  SalecycleRtm = 'SalecycleRtm',
  SalecycleOSR = 'SalecycleOSR',
  ThirdPartyRtm = 'ThirdPartyRtm',
}

export const allDataSources = Object.keys(DataSource);

export interface ExcludeEmailSource {
  type?: '.ExcludeEmailSource';
  excludedSources?: DataSource[];
}
